@if (isMixedCart && !isRenewal) {
    <div class="is-aligned-center" [ngClass]="{ 'is-justified-center': !uniqOffer }">
        @if (!user?.id && incitationPromo?.message?.incitation) {
            <div class="columns is-multiline">
                <div class="column is-12">
                    <trg-price
                        [size]="'is-level-6'"
                        [isMainPrice]="false"
                        [hasPeriod]="true"
                        [price]="subscription?.prices?.final"
                        [isDiscountPrice]="true"
                    />
                    <trg-price
                        [size]="'is-level-6'"
                        [hasIcon]="false"
                        [hasPeriod]="true"
                        [price]="subscription?.prices?.final - incitationPromo?.reductionAmount"
                        [isMainPrice]="true"
                        [isDiscountPrice]="false"
                    />
                </div>
                <div class="column is-12 mb-1">
                    <p class="subtitle">PRIX CLIENT BBOX</p>
                </div>
            </div>
        } @else {
            <div>
                <trg-price
                    [size]="subscriptionBlock ? 'price is-level-6 has-text-weight-bold' : 'price is-level-3'"
                    class="is-margin"
                    [hasPeriod]="true"
                    [price]="subscription?.prices?.final"
                    [isDiscountPrice]="false"
                />
            </div>
        }
        @if (subscription?.prices?.duration) {
            <p class="is-level-3 text mt-1 is-marginless">
                Pendant
                <span>{{ subscription?.prices?.duration }}</span>
                mois puis
                <trg-price
                    class="is-margin"
                    [price]="subscription | priceInitial"
                    [inheritFontSize]="true"
                    [isInlined]="true"
                    [hasPeriod]="true"
                />
            </p>
        }
    </div>
} @else {
    @if (!isRenewal || !renewalPrices) {
        <div>
            <trg-price
                [hasPeriod]="true"
                [price]="subscription?.prices?.final - promoAmount"
                [size]="subscriptionBlock ? 'price is-level-6 has-text-weight-bold' : 'price is-level-3'"
                class="is-margin"
            />
            @if (subscription?.prices?.duration) {
                <p class="is-level-3 text is-marginless pt-1">
                    Pendant
                    <span>{{ subscription?.prices?.duration }}</span>
                    mois puis
                    <trg-price
                        [isInlined]="true"
                        [price]="(subscription | priceInitial) - promoAmount"
                        class="is-margin"
                        [inheritFontSize]="true"
                        [hasPeriod]="true"
                    />
                </p>
            }
        </div>
    }
    @if (isRenewal && renewalPrices) {
        <div>
            <trg-price
                [hasPeriod]="true"
                [price]="renewalPrices.temporary"
                class="is-margin"
                [size]="subscriptionBlock ? 'price is-level-3 has-text-weight-bold' : 'price is-1'"
            />
            @if (renewalPrices.duration && renewalPrices.temporary !== renewalPrices.final) {
                <p>
                    {{ renewalPrices.durationLabel }} puis
                    <trg-price [price]="renewalPrices.final" [inheritFontSize]="true" />
                </p>
            }
            @if (renewalPrices.final !== renewalPrices.base) {
                <p>
                    au lieu de
                    <trg-price
                        [price]="renewalPrices.base"
                        class="is-margin"
                        [isInlined]="true"
                        [inheritFontSize]="true"
                    />
                </p>
            }
        </div>
    }
    @if (isRenewal && !!refundsList.length) {
        <div>
            <span class="paragraph title is-level-6">Ce prix inclut les remises suivantes&nbsp;:</span>
            @for (refund of refundsList; track refund) {
                <div>
                    <span class="paragraph text is-level-3">{{ refund.name }}&nbsp;</span>
                    <trg-price [price]="refund.amount" [size]="'is-level-6'" />
                    @if (refund.promoLabel) {
                        <span class="paragraph text is-level-3">{{ refund.promoLabel }}</span>
                    }
                </div>
            }
        </div>
    }
    <p></p>
}
